export default {
    customer:{
        name:'Company',
        name_placeholder:'Please enter the company name.',
        short_name:"Company Profile",
        short_name_placeholder:"Please enter the company profile.",
        customer_code:'Company ID',
        customer_code_placeholder:'Please enter the company ID.',
        customer_status:'Status',
        customer_type:'Company Type',
        area:'Area',
        area_placeholder:'Please enter the area.',
        area_code:'Area ID/SN',
        area_code_placeholder:'Please enter the area code.',
        address:'Address',
        address_placeholder:'Please enter the address.',
        contact:'Contact',
        contact_placeholder:'Please enter the contact.',
        phone:'Mobile/Phone',
        phone_placeholder:'Please enter the mobile/phone.',
        email:'Email',
        email_placeholder:'Please enter the email.',
        noti_methods:'Notify Customer',
        noti_methods_email:'Email',
        noti_methods_mobile:'SMS',
        description:'Description',


        //提示
        tip_before_del:"Deleting this company will also delete associated scopes, devices, users, and other resources. Confirm deletion?",
        tip_before_canc:"Deactivating this company will also disable associated roles, users, monitoring tools, and monitoring points. Confirm deactivation?",
        tip_actived:"Activation Successful",
        tip_cancelled:"Deactivation Successful",


        //模式切换
        mode_edit:'Edit Mode',
        mode_lookup:'View Mode',

        //对话框标题
        title_add:'Add Company',
        title_detail:'Company Information',
        title_edit_detail:'Edit Company',


        //返回的状态码
        code_200:'Successfully added',
        code_201:'Company created successfully, but failed to create the default role.',
        code_202:'Create company, default role succeeded, but create user failed.',
        code_203:'Company, default role, and user created successfully, but failed to sync contacts.',
        code_406:'Company ID can only contain uppercase and lowercase letters and digits, and the length cannot exceed 20 characters.',
        code_410:'Company type is required.',
        code_418:'Company name already exists.',
        code_420:'Company ID already exists.',
        code_421:'Email already exists.',
        code_422: 'Mobile number already exists.',
    }
}
